import { Brand, Schema } from '@blade/std-lib'

export const TelegramIdTypeId = 'tradebot-tma/telegramId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TelegramIdTypeId = typeof TelegramIdTypeId

export type TelegramId = Brand.Branded<string, TelegramIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TelegramId = Brand.nominal<TelegramId>()

export const TelegramIdSchema = Schema.String.pipe(
  Schema.fromBrand(TelegramIdTypeId, TelegramId),
)
